import React from 'react'
import { Link } from 'react-router-dom'
import { Tag } from 'antd'
import { EditableColumnType } from '../../components/data-table/interface'
import {
  SupplyDataset,
  SupplyRow,
  supplyCardPath,
  supplyDate,
  supplyDeliveryDate,
  supplyMoney,
  supplyText,
} from './model'

type SupplyListRow = SupplyRow & { id: string }

export const getSupplyColumns = (dataset: SupplyDataset): EditableColumnType<SupplyListRow>[] => [
  { title: 'Номер', dataIndex: 'Номер', key: 'number', width: 170, render: supplyText },
  { title: 'Дата', dataIndex: 'Дата', key: 'date', width: 150, render: supplyDate },
  ...(dataset !== 'receipts'
    ? [{ title: 'Плановая дата доставки', dataIndex: 'ПлановаяДатаДоставки', key: 'delivery_date', width: 190, render: supplyDeliveryDate }]
    : []),
  ...(dataset === 'requests'
    ? [{ title: 'Номер WD', dataIndex: 'Название', key: 'wd', width: 150, render: supplyText }]
    : []),
  { title: 'Поставщик', dataIndex: 'Поставщик', key: 'supplier', width: 220, render: supplyText },
  { title: 'Сумма', dataIndex: 'Сумма', key: 'sum', width: 130, render: supplyMoney },
  { title: 'Валюта', dataIndex: 'Валюта', key: 'currency', width: 100, render: supplyText },
  ...(dataset === 'requests'
    ? [
        { title: 'Статус', dataIndex: 'Статус', key: 'status', width: 170, render: supplyText },
        {
          title: 'Заказ поставщику',
          dataIndex: 'НомерЗаказа',
          key: 'order',
          width: 180,
          render: (value: string | null) =>
            value ? (
              <Link to={supplyCardPath('orders', value)} onClick={event => event.stopPropagation()}>
                {value}
              </Link>
            ) : (
              '—'
            ),
        },
      ]
    : dataset === 'orders'
    ? [{ title: 'Состояние', dataIndex: 'Состояние', key: 'state', width: 170, render: supplyText }]
    : [
        {
          title: 'Заказ поставщику',
          dataIndex: 'НомерЗаказа',
          key: 'order',
          width: 180,
          render: (value: string | null) =>
            value ? (
              <Link to={supplyCardPath('orders', value)} onClick={event => event.stopPropagation()}>
                {value}
              </Link>
            ) : (
              '—'
            ),
        },
        {
          title: 'Расхождения в 1С',
          dataIndex: 'ЕстьРасхождения',
          key: 'difference',
          width: 170,
          render: (value: boolean) => (value ? <Tag color="orange">Есть</Tag> : '—'),
        },
      ]),
]

export const getSupplyItemColumns = (dataset: SupplyDataset) => [
  { title: 'Номенклатура', dataIndex: 'Номенклатура', key: 'name', render: supplyText },
  ...(dataset === 'requests'
    ? [
        { title: 'Упаковок', dataIndex: 'КоличествоУпаковок', key: 'packages', render: supplyText },
        {
          title: 'Единица упаковки',
          dataIndex: 'ЕдиницаУпаковки',
          key: 'unit',
          render: supplyText,
        },
        {
          title: 'В единицах хранения',
          dataIndex: 'КоличествоХранения',
          key: 'stored',
          render: supplyText,
        },
      ]
    : [
        { title: 'Количество', dataIndex: 'Количество', key: 'quantity', render: supplyText },
        { title: 'Единица', dataIndex: 'Единица', key: 'unit', render: supplyText },
      ]),
  { title: 'Цена', dataIndex: 'Цена', key: 'price', render: supplyMoney },
  { title: 'Сумма', dataIndex: 'Сумма', key: 'sum', render: supplyMoney },
  ...(dataset === 'requests'
    ? [{ title: 'Статус', dataIndex: 'Статус', key: 'status', render: supplyText }]
    : []),
  ...(dataset === 'orders'
    ? [
        {
          title: 'Позиция заявки на снабжение',
          dataIndex: 'ПозицияЗаявки',
          key: 'request',
          render: supplyText,
        },
      ]
    : []),
]
